import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import Header_LOGO from '../images/header-logo.png';

const NOTFOUND = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        mt: 10,
      }}
    >
      <img
        alt={'Barbers Limited'}
        src={Header_LOGO}
        width={'105em'}
        className={'not-found-image'}
      />
      <Typography
        variant="h1"
        style={{
          color: '#000',
          fontWeight: 'bold',
          marginTop: '-25px',
          fontSize: '70px',
        }}
      >
        404
      </Typography>
      <Typography
        variant="h4"
        style={{
          color: '#000',
          fontWeight: 'bold',
          fontSize: '12px',
          marginTop: '4px',
        }}
      >
        Page Not Found
      </Typography>
      <Typography
        variant="h6"
        style={{
          color: '#000',
          fontSize: '12px',
          fontWeight: 'normal',
          marginTop: '50px',
        }}
      >
        Click button to go back to home page
      </Typography>
      <Button
        variant="contained"
        style={{
          backgroundColor: '#000',
          color: '#fff',
          marginTop: '20px',
          width: '200px',
        }}
        onClick={() => navigate('/')}
      >
        Back{' '}
      </Button>
    </Box>
  );
};

export default NOTFOUND;
